import { Card, CardBlockCode } from '@generated-types';

export const isBlocked = (card: Card): card is Card & Required<Pick<Card, 'block'>> => !!card.block;

export const isSoftBlocked = (card: Card) => isBlocked(card) && card.block.code === CardBlockCode.SOFT_BLOCK;

export const isHardBlocked = (card: Card) => isBlocked(card) && !isSoftBlocked(card);
